module.exports = __webpack_public_path__ + "img/valet-julien.ee66f2c2.jpeg";